export default {
  id: 33,
  title: 'Target #33 - Birdie',
  url: 'https://cssbattle.dev/play/33',
  colors: ['#1A4341', '#998235', '#F3AC3C', '#0B2429'],
  solution:
    '<a a><a b><a c><style>body{background:#1a4341}a{position:fixed}a[a]{width:75;height:150;top:75;left:125;background:#998235;border-radius:75px 0 0 75px}a[b]{width:100;height:100;top:50;left:200;background:#f3ac3c;border-radius:0 100px 0 0}a[c]{width:30;height:30;top:105;left:155;background:#0b2429;border-radius:50%}</style>',
}
